import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const CREATE_RESPONSE_OPTION = questionnaireGql(/* GraphQL */ `
  mutation createResponseOptionV2($input: CreateResponseOptionV2Input!) {
    createResponseOptionV2(input: $input) {
      ...DraftEntryResponseOption
    }
  }
`)
